<template>
    <div class="sustainability-page-presentations">
        <div class="container">
            <div class="sustainability-page-presentations__body">
                <div
                    v-if="presentations && presentations.length"
                    class="sustainability-page-presentations__block sustainability-page-presentations__block--presentations"
                 >
                    <z-caption
                        size="3xl"
                        decor-left
                        decor-right
                        class="sustainability-page-presentations__title sustainability-page__title"
                    >
                        <span v-html="text.presentations.title" />
                    </z-caption>
                    <z-filelist
                        size="m"
                        class="sustainability-page-presentations__list sustainability-page-presentations__list--presentations"
                    >
                        <z-filelist-item
                            v-for="(presentation, index) in presentations"
                            :key="index"
                            :name="presentation.name"
                            :href="presentation.mlDocs.link"
                            :icon-name="`file/${presentation.mlDocs.type}`"
                            :file-size="presentation.mlDocs.size"
                            :file-type="presentation.mlDocs.type"
                            class="sustainability-page-presentations__file"
                        ></z-filelist-item>
                    </z-filelist>
                    <z-button
                        tag="a"
                        kind="text"
                        size="l"
                        href="/investors/presentations-and-briefings/#tabs-esg-presentation-2024"
                        class="sustainability-page-presentations__btn"
                    >
                        <template v-slot:left>
                            <z-icon
                                name="arrow-long"
                                dir="right"
                                width="16px"
                                height="16px"
                            ></z-icon>
                        </template>
                        <span v-html="text.presentations.button" />
                    </z-button>
                </div>

                <div
                    v-if="news && news.length"
                    class="sustainability-page-presentations__block sustainability-page-presentations__block--news"
                >
                    <z-caption
                        size="3xl"
                        decor-left
                        decor-right
                        class="sustainability-page-presentations__title sustainability-page__title"
                    >
                        {{ text.news.title }}
                    </z-caption>
                    <z-filelist
                        size="l"
                        class="sustainability-page-presentations__list sustainability-page-presentations__list--news"
                    >
                        <a
                            v-for="(newsItem, index) in news"
                            :key="index"
                            :href="newsItem.detailPageUrl"
                            class="sustainability-page-presentations__news-item"
                        >
                            <span class="sustainability-page-presentations__news-date">
                                {{ newsItem.activeFrom | momentFilter('DD MMMM YYYY') }}
                            </span>
                            <span
                                class="sustainability-page-presentations__news-title"
                                v-html="newsItem.name"
                            />
                        </a>
                    </z-filelist>
                    <z-button
                        tag="a"
                        kind="text"
                        size="l"
                        href="/news-and-media/press-releases-and-news/?sources[]=115"
                        class="sustainability-page-presentations__btn"
                    >
                        <template v-slot:left>
                            <z-icon
                                name="arrow-long"
                                dir="right"
                                width="16px"
                                height="16px"
                            ></z-icon>
                        </template>
                        <span v-html="text.news.button" />
                    </z-button>
                </div>

                <div class="sustainability-page-presentations__card-wrapper">
                    <card-scale
                        :title="text.card.title"
                        image="/images/sustainability/new/esg-politics.webp"
                        link="/sustainability/governance/esg-policies/"
                        class="sustainability-page-presentations__card"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'presentations',
    props: {
        presentations: Array,
        news: Array
    },
    data () {
        return {
            text: {
                presentations: {
                    title: localize({
                        ru: 'ESG презентации',
                        en: 'ESG Presentations'
                    }),
                    button: localize({
                        ru: 'Все презентации',
                        en: 'All Presentations'
                    })
                },
                news: {
                    title: localize({
                        ru: 'ESG-новости',
                        en: 'ESG News'
                    }),
                    button: localize({
                        ru: 'Все ESG-новости',
                        en: 'All ESG News'
                    })
                },
                card: {
                    title: localize({
                        ru: 'Наши ESG политики',
                        en: 'Our ESG Policies'
                    })
                }
            }
        }
    }
}
</script>

<style lang="scss">
.sustainability-page-presentations {
    $parent: &;
    background: $token-colors-gray-10;
    padding-top: $token-spacers-2-s;
    padding-bottom: $token-spacers-3-xl;

    @include breakpoint(mobile) {
        padding-top: 0;
        padding-bottom: $token-spacers-xl;
    }

    &__body {
        display: flex;
        gap: $token-spacers-xl;

        @include breakpoint(tablet) {
            flex-wrap: wrap;
        }

        @include breakpoint(mobile) {
            flex-direction: column;
            gap: 0;
        }
    }

    &__block {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: $token-spacers-2-s;

        @include breakpoint(tablet) {
            gap: $token-spacers-xs;
        }

        @include breakpoint(mobile) {
            gap: 0;
        }

        &--presentations {
            @include breakpoint(mobile) {
                #{$parent}__title {
                    margin-top: 32px;
                }
            }
        }
    }

    &__title {
        width: 100%;

        &.z-caption {
            white-space: nowrap;
        }
    }

    &__list {
        &--presentations {
            max-width: 470px;
            padding-top: 16px;

            @include breakpoint(mobile) {
                padding-top: 0;
            }
        }

        &--news {
            max-width: 486px;
        }
    }

    &__file {
        .z-link {
            font-weight: 600;
            color: $token-colors-gray-60;
        }
    }

    &__btn {
        margin-top: auto;

        @include breakpoint(mobile) {
            font-style: 18px;
            margin-top: $token-spacers-xs;
        }
    }

    &__news-item {
        display: block;
        text-decoration: none;

        & + & {
            margin-top: 32px;
        }

        &:hover {
            #{$parent}__news-title {
                color: $token-colors-link-defolt-hover;
            }
        }
    }

    &__news-date {
        color: #737B90;
        font-size: 14px;
        line-height: 140%;
        letter-spacing: 1.4px;
        margin-bottom: 8px;
    }

    &__news-title {
        font-size: 18px;
        font-weight: 600;
        line-height: 140%;
        color: $token-colors-gray-60;
        transition: color $transition;
        display: -webkit-box;
        line-clamp: 3;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__card-wrapper {
        display: flex;
        padding-top: 82px;

        @include breakpoint(tablet) {
            width: 100%;
            padding-top: 0;
        }

        @include breakpoint(mobile) {
            margin-top: $token-spacers-l;
        }
    }

    &__card {
        max-width: 490px;

        @include breakpoint(tablet) {
            max-width: 100%;
            width: 100%;
            max-height: 340px;
        }

        @include breakpoint(mobile) {
            max-height: none;
        }

        .card-scale__content {
            bottom: 52px;

            @include breakpoint(mobile) {
                left: 16px;
            }
        }
    }
}
</style>
